// extracted by mini-css-extract-plugin
module.exports = {"item-column":"item-column--1tgYRKANcg","itemColumn":"item-column--1tgYRKANcg"};